module.exports = __webpack_public_path__ + "img/re-sent-rxnt-inactive-icon-new.eddcf048.svg";